module.exports = __webpack_public_path__ + "img/1.85f9db5b.jpeg";